/** Keys used by ParentSection required-doc checklist (must match REQUIRED_PARENT_DOCUMENTS keys). */
const PORTAL_FORM_KEYS = new Set(['photo_release', 'code_of_conduct', 'usa_hockey']);

/**
 * Best-effort mapping from free-text titles (legacy uploads, "Other", etc.) to portal form keys.
 */
export function inferPortalFormKeyFromTitle(title) {
  if (typeof title !== 'string') return null;
  const t = title.trim().toLowerCase().replace(/\s+/g, ' ');
  if (!t) return null;
  if (t === 'photo release form') return 'photo_release';
  if (t === 'code of conduct') return 'code_of_conduct';
  if (t === 'usa hockey') return 'usa_hockey';
  if (t.includes('photo') && t.includes('release')) return 'photo_release';
  if (t.includes('code') && t.includes('conduct')) return 'code_of_conduct';
  if (t.includes('usa') && t.includes('hockey')) return 'usa_hockey';
  return null;
}

/**
 * Resolves checklist key: explicit portalFormKey, or inferred from title (covers legacy + "other").
 */
export function effectivePortalFormKey(row) {
  if (!row || typeof row !== 'object') return null;
  const pk = row.portalFormKey;
  if (typeof pk === 'string' && PORTAL_FORM_KEYS.has(pk)) return pk;
  const inferred = inferPortalFormKeyFromTitle(row.title);
  if (inferred) return inferred;
  return null;
}

/**
 * Whether this upload row satisfies a given required document (by key + canonical label).
 */
export function uploadRowMatchesRequiredDoc(row, requiredDoc) {
  if (!row || !requiredDoc?.key) return false;
  const eff = effectivePortalFormKey(row);
  if (eff === requiredDoc.key) return true;
  return (
    !row.portalFormKey &&
    typeof row.title === 'string' &&
    row.title.trim().toLowerCase() === (requiredDoc.label || '').trim().toLowerCase()
  );
}

/** Firebase Storage object path for an `uploaded_documents` row (new: uploads/{uid}/file; legacy: uploads/file). */
export function uploadedDocumentStorageRefPath(row) {
  if (!row || typeof row !== 'object') return null;
  const fn = typeof row.filename === 'string' ? row.filename : '';
  if (!fn) return null;
  const uid = typeof row.uploaderUid === 'string' ? row.uploaderUid.trim() : '';
  if (uid) return `uploads/${uid}/${fn}`;
  return `uploads/${fn}`;
}

/** For merging / sorting Firestore `timestamp` variants. */
export function uploadedDocumentTimestampMs(row) {
  const raw = row?.timestamp;
  if (!raw) return 0;
  if (typeof raw.toDate === 'function') {
    const d = raw.toDate();
    return Number.isNaN(d.getTime()) ? 0 : d.getTime();
  }
  if (typeof raw.seconds === 'number') return raw.seconds * 1000;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}
